import React, { useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { withAppContext } from 'src/store/initAppContext';
import { useLazyQuery } from "@apollo/client";
import { GET_USERINFO } from 'src/graphql/member';
import util from 'src/util/util';
import cookieUtil from 'src/util/cookieUtil';
import { ECookieName } from 'src/util/utilModel';
import { Notify } from 'src/components/Notification';
import styled from 'styled-components';


const SocialMediaStatusPage = (props: any) => {
    const {
        app: { brandId },
    } = props;
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [token, setToken] = useState(null);

    const [getUserInfo] = useLazyQuery(GET_USERINFO, {
        fetchPolicy: "network-only",
        onError: (error) => {
            Notify.error(error.message);
            navigate("/Login");
            // setErrorMessage(error.message);
        },
        onCompleted: (data) => {
            handleSuccess(data);
        },
    });

    useEffect(() => {
        const iserror = searchParams.get("err") || "";
        const istoken = searchParams.get("t") || "";

        if (iserror) {
            const errorMsg = decodeURIComponent(iserror || '');
            Notify.error(errorMsg);
            navigate("/Login");
        }
        else if (istoken) {
            setToken(istoken);
            getUserInfo({
                variables: {
                    input: {
                        token: istoken,
                    },
                },
            })
        }

    }, []);

    const handleSuccess = (data) => {
        const payload = util.getValue(data, ["member", "userInfo"], {});
        if (payload.length !== 0) {
            // cookieUtil.remove(ECookieName.COOKIE_TOKEN);
            cookieUtil.set(ECookieName.COOKIE_USERNAME, payload.username, 30);
            cookieUtil.set(ECookieName.COOKIE_MEMBERID, payload.memberId, 30);
            cookieUtil.set(
                ECookieName.COOKIE_ORIGINAL_MEMBERID,
                payload.memberId,
                30
            );

            cookieUtil.set(
                ECookieName.COOKIE_ORDER_LIMIT,
                JSON.stringify(payload.orderLimit),
                30
            );

            // cookieUtil.set(ECookieName.COOKIE_LANG, "en-us", 30);
            const selectedLanguage = cookieUtil.get(ECookieName.COOKIE_LANG) || "en-us";
            cookieUtil.set(ECookieName.COOKIE_LANG, selectedLanguage, 30);
            
            cookieUtil.set(
                ECookieName.COOKIE_EXCHANGE_RATE,
                payload.exchangeRate,
                30
            );

            cookieUtil.set(ECookieName.COOKIE_ACCOUNT_TYPE, "CLIENT");
            cookieUtil.set(
                ECookieName.COOKIE_IS_SUBACCOUNT,
                payload.isSubAccount ? "1" : ""
            );
            cookieUtil.set(
                ECookieName.COOKIE_TOKEN,
                token ? token : localStorage.getItem(ECookieName.COOKIE_TOKEN)
            );
            cookieUtil.set(
                ECookieName.COOKIE_ACCOCIATIONS,
                JSON.stringify(payload.associations || [])
            );

            cookieUtil.set(
                ECookieName.COOKIE_USERINFO,
                JSON.stringify(payload || {})
            );

            cookieUtil.set(
                ECookieName.COOKIE_BFPT_INFO,
                JSON.stringify(
                    payload.betfairInfo.map(
                        (_: { betfairPt: number; categoryId: number }) => ({
                            bfPt: _.betfairPt,
                            categoryId: _.categoryId,
                        })
                    )
                ),
                30
            );
            cookieUtil.set(
                ECookieName.COOKIE_BRAND_ID,
                payload.brandId ? payload.brandId : 31
            );

            //CRM
            sessionStorage.setItem('uin', encodeURI((JSON.stringify({ brandId, username: payload.username, memberId: payload.memberId, isreg: true }))));
            //console.log('stateFTD',JSON.stringify(userData));
            navigate("/", {
                state: {
                    first: payload.first_time_login,
                    fd: payload.first_time_deposit,
                },
            });
            window.location.reload();
        }
    };

    return (
        <Container> Processing... </Container>
    )
}

export default withAppContext(SocialMediaStatusPage);

//styled Component
const Container = styled.div`
    display: flex;
    height: 300px;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100%;
    color:#fff;
`